import AbstractRest from "./AbstractRest.ts";
import axios from "axios";

class ImageRest extends AbstractRest {

    constructor() {
        super("images");
    }

    getUrlById(id: string): string {
        return this.baseUrl + "/" + id;
    }

    getUrlByName(name: string, force_reload: boolean = false): string {
        return (force_reload ?
            this.baseUrl + "/byName/" + name + "?t=" + new Date().getTime() :
            this.baseUrl + "/byName/" + name);
    }

    async checkImageExists(body: unknown): Promise<boolean> {
        return axios.post(this.baseUrl + "/exists", body).then(
            res => {
                return res.data.data.exists
            }
        )
    }

    upload(imageFile: File) {
        const formData = new FormData();
        formData.append('image', imageFile);

        return axios.post(this.baseUrl, formData);
    }


}

export default ImageRest;